import { useState, useEffect } from 'react';
import { NavLink, useLocation, matchPath, useNavigate } from 'react-router-dom';
import { FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { BsBoxSeam } from 'react-icons/bs';
import { TbSettingsDollar } from "react-icons/tb";
import { FaCcAmazonPay } from 'react-icons/fa6';
import { MdDashboard, MdCalendarToday } from "react-icons/md";
import { FaUserFriends, FaTruck } from "react-icons/fa";

import logo from '../assets/FareFuel_logo.png';

const Redemp_topbar = () => {
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
   const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);

   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
   const handleMobileClose = () => isMobile && setIsSidebarOpen(false);

   const navigate = useNavigate();

   const handleLogout = () => {
      sessionStorage.clear();
      navigate("/redemption-login");
   };

   useEffect(() => {
      const handleResize = () => {
         const isNowMobile = window.innerWidth <= 1024;
         setIsMobile(isNowMobile);
         setIsSidebarOpen(!isNowMobile);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
   }, []);

   const linkClass =
      "flex items-center gap-2 py-2 px-3 text-lg rounded-md font-semibold leading-8 transition-colors";
   const hoverClass = "hover:bg-yellow-200";
   const iconClass = "text-blue-600";

   return (
      <>
         {/* Header */}
         <header
            className={`fixed top-0 ${isMobile ? "left-0" : "left-64"
               } right-0 h-16 bg-white shadow z-40 px-4 flex items-center justify-between transition-all duration-300`}
         >
            <div className="flex items-center gap-4">
               {isMobile && (
                  <button
                     onClick={toggleSidebar}
                     className="p-2 rounded hover:bg-gray-100"
                  >
                     {isSidebarOpen ? <FiX size={22} /> : <FiMenu size={22} />}
                  </button>
               )}
               <h1 className="text-lg font-semibold whitespace-nowrap">
                  Welcome Redemption Center!!
               </h1>
            </div>

            <div className="flex items-center gap-4">
               <button
                  onClick={handleLogout}
                  className="p-2 rounded-full text-red-500 hover:text-red-700 hover:bg-gray-100"
                  title="Logout"
               >
                  <FiLogOut size={20} />
               </button>
            </div>
         </header>

         {/* Sidebar */}
         <aside
            className={`fixed top-0 left-0 w-64 h-screen z-50 
        bg-lime-300 bg-gradient-to-b from-lime-400 to-lime-100 
        text-green-900 shadow-lg 
        transition-transform duration-300 ease-in-out 
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        xl:translate-x-0 
        overflow-y-auto scrollbar-hide`}
         >
            <div className="xl:hidden flex justify-end p-4">
               <button
                  onClick={toggleSidebar}
                  className="text-green-900 hover:text-black"
                  title="Close Sidebar"
               >
                  <FiX size={28} />
               </button>
            </div>

            <div className="flex flex-col h-full">
               <div className="p-4 flex items-center justify-center space-x-2">
                  <img src={logo} alt="FareFuel" className="w-40" />
               </div>

               <nav className="flex-1 px-4 space-y-2 text-[16px] font-medium">
                  <NavLink to="/redem-dashboard" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <MdDashboard size={20} className={iconClass} /> Dashboard
                  </NavLink>

                  <NavLink to="/redem-account" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <FaUserFriends size={20} className={iconClass} /> My Account
                  </NavLink>

                  <NavLink to="/redem-customerlist" onClick={handleMobileClose} 
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <FaUserFriends size={20} className={iconClass} /> Customers
                  </NavLink>


                  <NavLink to="/redem-driverlist" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}` }>
                     <FaTruck size={20} className={iconClass} /> Drivers
                  </NavLink>

                  <NavLink to="/redem-pickuprequests" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <BsBoxSeam size={20} className={iconClass} /> Pickup requests
                  </NavLink>

                  <NavLink to="/redem-schedule" onClick={handleMobileClose} 
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <MdCalendarToday size={20} className={iconClass} /> RC Schedule
                  </NavLink>

                  <NavLink to="/redem-customer-payments" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     <FaCcAmazonPay size={20} className={iconClass} /> Customer Payments
                  </NavLink>

                  <NavLink to="/redem-driver-payments" onClick={handleMobileClose}
                     className={({ isActive }) => `${linkClass} ${hoverClass} ${isActive ? "bg-yellow-300" : ""}`}>
                     < TbSettingsDollar size={20} className={iconClass} /> Driver Payments
                  </NavLink>
               </nav>
            </div>
         </aside>

         {/* Overlay */}
         {isMobile && isSidebarOpen && (
            <div
               className="fixed inset-0 bg-black bg-opacity-40 z-40"
               onClick={toggleSidebar}
            ></div>
         )}
      </>
   );

};

export default Redemp_topbar;
